"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityBase = void 0;
const typeorm_1 = require("typeorm/browser");
const documentation_type_1 = require("./documentation-type");
const invoicing_target_1 = require("./invoicing-target");
const external_id_type_1 = require("./external-id-type");
class OpportunityBase {
}
__decorate([
    (0, typeorm_1.PrimaryColumn)({
        type: 'character varying',
        length: 18,
        name: 'sfid',
    }),
    __metadata("design:type", String)
], OpportunityBase.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: documentation_type_1.DocumentationTypeEnum,
        default: documentation_type_1.DocumentationTypeEnum.NONE,
        name: 'dokumentationstyp__c',
    }),
    __metadata("design:type", String)
], OpportunityBase.prototype, "documentationType", void 0);
__decorate([
    (0, typeorm_1.Index)('idx_trgm_opportunity_name', { synchronize: false }),
    (0, typeorm_1.Column)('character varying', {
        nullable: false,
        length: 121,
        name: 'name',
    }),
    __metadata("design:type", String)
], OpportunityBase.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        nullable: false,
        enum: invoicing_target_1.InvoicingTargetEnum,
        name: 'invoicing_target__c',
    }),
    __metadata("design:type", String)
], OpportunityBase.prototype, "invoicingTarget", void 0);
__decorate([
    (0, typeorm_1.Column)({
        nullable: true,
        type: 'enum',
        enum: external_id_type_1.ExternalIdTypeEnum,
        name: 'external_id_type__c',
    }),
    __metadata("design:type", String)
], OpportunityBase.prototype, "externalIdType", void 0);
__decorate([
    (0, typeorm_1.Column)({
        nullable: true,
        type: 'integer',
        name: 'default_days_for_delivery__c',
    }),
    __metadata("design:type", Number)
], OpportunityBase.prototype, "defaultDaysForDelivery", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'email_type__c',
        nullable: true,
        length: 50,
    }),
    __metadata("design:type", String)
], OpportunityBase.prototype, "emailType", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'integer',
        name: 'assembly_time_days__c',
        nullable: true,
    }),
    __metadata("design:type", Number)
], OpportunityBase.prototype, "assemblyTimeDays", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('varchar', {
        length: 18,
        name: 'accountid',
    }),
    __metadata("design:type", Number)
], OpportunityBase.prototype, "brandId", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'bool',
        name: 'readiness_date_required__c',
        default: false,
    }),
    __metadata("design:type", Boolean)
], OpportunityBase.prototype, "readinessDateRequired", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)({
        type: 'bool',
        name: 'test_opportunity__c',
        default: false,
    }),
    __metadata("design:type", Boolean)
], OpportunityBase.prototype, "testOpportunity", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'bool',
        name: 'multiday__c',
        default: false,
    }),
    __metadata("design:type", Boolean)
], OpportunityBase.prototype, "multiDay", void 0);
exports.OpportunityBase = OpportunityBase;
//# sourceMappingURL=opportunity-base.js.map